document.addEventListener("DOMContentLoaded", () => {
  const collectionRouteOverrides = {
    "/collections/theordinary-new-and-featured-fond-farewell": "/collections/theordinary-new-and-featured-fond-farewell-shop",
    "/collections/theordinary-new-and-featured-gifts-all-gifts": "/collections/theordinary-new-and-featured-gifts-all-gifts-shop",
    "/collections/theordinary-new-and-featured-gifts-gift-sets": "/collections/theordinary-new-and-featured-gifts-gift-sets-shop",
    "/collections/theordinary-new-and-featured-gifts-gift-cards": "/collections/theordinary-new-and-featured-gifts-gift-cards-shop",
    "/collections/theordinary-skincare-shop-by-concern-look-of-redness": "/collections/theordinary-skincare-shop-by-concern-look-of-redness-shop",
    "/collections/theordinary-skincare-shop-by-concern-visible-shine": "/collections/theordinary-skincare-shop-by-concern-visible-shine-shop",
    "/collections/theordinary-skincare-shop-by-concern-antioxidant-support": "/collections/theordinary-skincare-shop-by-concern-antioxidant-support-shop",
    "/collections/theordinary-skincare-shop-by-step-step-1-prep": "/collections/theordinary-skincare-shop-by-step-step-1-prep-shop",
    "/collections/theordinary-skincare-shop-by-step-facial-cleansers": "/collections/theordinary-skincare-shop-by-step-facial-cleansers-shop",
    "/collections/theordinary-skincare-shop-by-step-toners-and-essences": "/collections/theordinary-skincare-shop-by-step-toners-and-essences-shop",
    "/collections/theordinary-skincare-shop-by-step-face-oils": "/collections/theordinary-skincare-shop-by-step-face-oils-shop",
    "/collections/theordinary-skincare-shop-by-step-moisturizers": "/collections/theordinary-skincare-shop-by-step-moisturizers-shop",
    "/collections/theordinary-skincare-shop-by-ingredients-retinoids": "/collections/theordinary-skincare-shop-by-ingredients-retinoids-shop",
    "/collections/theordinary-skincare-shop-by-ingredients-vitamin-c": "/collections/theordinary-skincare-shop-by-ingredients-vitamin-c-shop",
    "/collections/theordinary-skincare-shop-by-ingredients-antioxidants": "/collections/theordinary-skincare-shop-by-ingredients-antioxidants-shop",
    "/collections/theordinary-skincare-shop-by-ingredients-squalane": "/collections/theordinary-skincare-shop-by-ingredients-squalane-shop",
    "/collections/theordinary-body-plus-hair-lash-and-brow-treatments": "/collections/theordinary-body-plus-hair-lash-and-brow-treatments-shop",
    "/collections/theordinary-body-plus-hair-lip-care": "/collections/theordinary-body-plus-hair-lip-care-shop",
    "/collections/theordinary-sets-and-collections": "/collections/theordinary-sets-and-collections-shop"
  };

  const refreshedProductPaths = new Set([
    "/products/100-cold-pressed-virgin-marula-face-oil-100389",
    "/products/100-fermented-rose-hip-seed-oil-100681",
    "/products/100-l-ascorbic-acid-powder-vitamin-c-100390",
    "/products/100-organic-cold-pressed-moroccan-argan-face-oil-100393",
    "/products/100-organic-cold-pressed-rose-hip-seed-face-oil-100394",
    "/products/100-plant-derived-squalane-face-oil-100398",
    "/products/aloe-2-nag-2-solution-blemish-serum-100618",
    "/products/ascorbyl-glucoside-solution-12-vitamin-c-100405",
    "/products/ascorbyl-tetraisopalmitate-solution-20-in-vitamin-f-vitamin-c-100406",
    "/products/euk-134-01-antioxidant-serum-100417",
    "/products/gift-card-100570",
    "/products/glucoside-foaming-face-cleanser-100616",
    "/products/glycolipid-cream-face-cleanser-100615",
    "/products/granactive-retinoid-2-emulsion-serum-100419",
    "/products/granactive-retinoid-5-in-squalane-serum-100421",
    "/products/lash-curl-finisher-100732",
    "/products/multi-active-delivery-essence-100706",
    "/products/multi-antioxidant-radiance-serum-100716",
    "/products/multi-peptide-lash-brow-serum-100111",
    "/products/natural-moisturizing-factors-ha-for-scalp-hair-scalp-treatment-100422",
    "/products/pha-5-exfoliating-lip-serum-100721",
    "/products/pycnogenol-5-antioxidant-serum-100437",
    "/products/resveratrol-3-ferulic-acid-3-antioxidant-serum-100438",
    "/products/retinal-02-emulsion-100646",
    "/products/retinol-02-in-squalane-serum-100439",
    "/products/retinol-05-in-squalane-serum-100440",
    "/products/retinol-1-in-squalane-serum-100441",
    "/products/saccharomyces-ferment-30-milky-toner-100647",
    "/products/salicylic-acid-2-anhydrous-solution-exfoliator-100442",
    "/products/soothing-barrier-support-serum-gift-set-100736",
    "/products/squalane-amino-acids-lip-balm-100657",
    "/products/sulfur-10-powder-to-cream-concentrate-100708",
    "/products/the-acne-set-100631",
    "/products/the-age-support-set-100719",
    "/products/the-antioxidant-collection-200126",
    "/products/the-barrier-support-collection-200124",
    "/products/the-body-care-collection-200135",
    "/products/the-bright-set-100664",
    "/products/the-daily-set-100649",
    "/products/the-eye-lash-and-brow-collection-300129",
    "/products/the-face-and-body-gift-set-100729",
    "/products/the-hair-and-scalp-collection-200127",
    "/products/the-hand-collection-200139",
    "/products/the-hydration-collection-200133",
    "/products/the-mini-discovery-set-100680",
    "/products/the-mini-icons-skincare-set-100679",
    "/products/the-most-loved-holiday-collection-200128",
    "/products/the-multi-peptide-collection-200130",
    "/products/the-refine-and-regenerate-collection-200137",
    "/products/the-sensitive-skin-collection-200134",
    "/products/the-smooth-skin-collection-200123",
    "/products/the-uneven-skin-tone-collection-200125",
    "/products/the-vitamin-c-a-collection-200132",
    "/products/vitamin-c-suspension-23-ha-spheres-2-vitamin-c-100451"
  ]);

  const getOverridePath = (pathname) => {
    if (collectionRouteOverrides[pathname]) {
      return collectionRouteOverrides[pathname];
    }
    if (refreshedProductPaths.has(pathname)) {
      return `${pathname}-shop`;
    }
    return null;
  };

  const overridePath = getOverridePath(window.location.pathname);
  if (overridePath) {
    const redirectUrl = new URL(window.location.href);
    redirectUrl.pathname = overridePath;
    if (!redirectUrl.searchParams.has("cache")) {
      redirectUrl.searchParams.set("cache", `${Date.now()}-route-override`);
    }
    window.location.replace(redirectUrl.toString());
    return;
  }

  const rewriteAnchorHref = (anchor) => {
    const rawHref = anchor.getAttribute("href");
    if (!rawHref) return;
    try {
      const url = new URL(rawHref, window.location.origin);
      const override = getOverridePath(url.pathname);
      if (!override) return;
      url.pathname = override;
      anchor.setAttribute("href", `${url.pathname}${url.search}${url.hash}`);
    } catch {
      return;
    }
  };

  document.querySelectorAll("a[href]").forEach(rewriteAnchorHref);
  document.addEventListener("click", (event) => {
    const anchor = event.target.closest("a[href]");
    if (!anchor) return;
    rewriteAnchorHref(anchor);
  });

  document.querySelectorAll("[data-announcement-rotator]").forEach((root) => {
    const items = Array.from(root.querySelectorAll(".to-header__announcement-item"));
    if (items.length < 2) return;
    let index = items.findIndex((item) => item.classList.contains("is-active"));
    if (index < 0) index = 0;
    setInterval(() => {
      items[index].classList.remove("is-active");
      index = (index + 1) % items.length;
      items[index].classList.add("is-active");
    }, 4200);
  });

  document.querySelectorAll("[data-hero-carousel]").forEach((root) => {
    const slides = Array.from(root.querySelectorAll(".to-home-hero__slide"));
    const dots = Array.from(root.querySelectorAll(".to-home-hero__dot"));
    if (!slides.length) return;
    let index = slides.findIndex((slide) => slide.classList.contains("is-active"));
    if (index < 0) index = 0;

    const activate = (next) => {
      slides[index]?.classList.remove("is-active");
      dots[index]?.classList.remove("is-active");
      index = (next + slides.length) % slides.length;
      slides[index]?.classList.add("is-active");
      dots[index]?.classList.add("is-active");
    };

    root.querySelector("[data-hero-prev]")?.addEventListener("click", () => activate(index - 1));
    root.querySelector("[data-hero-next]")?.addEventListener("click", () => activate(index + 1));
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener("click", () => activate(dotIndex));
    });

    if (slides.length > 1) {
      setInterval(() => activate(index + 1), 6500);
    }
  });

  document.querySelectorAll("[data-scroll-section]").forEach((root) => {
    const track = root.querySelector("[data-scroll-track]");
    const prevButton = root.querySelector("[data-scroll-prev]");
    const nextButton = root.querySelector("[data-scroll-next]");
    if (!track) return;
    const getAmount = () => {
      const firstItem = track.querySelector(".to-scroller__item");
      const itemWidth = firstItem?.getBoundingClientRect().width || 280;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || "0") || 0;
      const mobile = window.matchMedia("(max-width: 989px)").matches;
      const rawStep = mobile ? root.dataset.scrollStepMobile : root.dataset.scrollStepDesktop;
      const step = Number.parseInt(rawStep || "", 10);
      const itemsPerClick = Number.isFinite(step) && step > 0 ? step : 1;
      return (itemWidth + gap) * itemsPerClick;
    };
    const syncButtons = () => {
      if (!prevButton && !nextButton) return;
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      const scrollLeft = Math.round(track.scrollLeft);
      if (prevButton) prevButton.hidden = scrollLeft <= 4;
      if (nextButton) nextButton.hidden = scrollLeft >= maxScroll - 4;
    };
    prevButton?.addEventListener("click", () => {
      track.scrollBy({ left: -getAmount(), behavior: "smooth" });
    });
    nextButton?.addEventListener("click", () => {
      track.scrollBy({ left: getAmount(), behavior: "smooth" });
    });
    track.addEventListener("scroll", syncButtons, { passive: true });
    window.addEventListener("resize", syncButtons);
    syncButtons();
  });

  document.querySelectorAll("[data-ordinary-header]").forEach((root) => {
    const openButton = root.querySelector("[data-menu-open]");
    const closeButton = root.querySelector("[data-menu-close]");
    const overlay = root.querySelector("[data-menu-overlay]");

    const setOpen = (value) => {
      root.setAttribute("data-menu-open", value ? "true" : "false");
      document.documentElement.style.overflow = value ? "hidden" : "";
      document.body.style.overflow = value ? "hidden" : "";
    };

    openButton?.addEventListener("click", () => setOpen(true));
    closeButton?.addEventListener("click", () => setOpen(false));
    overlay?.addEventListener("click", () => setOpen(false));
  });

  document.querySelectorAll("[data-product-gallery]").forEach((root) => {
    const thumbs = Array.from(root.querySelectorAll("[data-product-thumb]"));
    const mediaItems = Array.from(root.querySelectorAll("[data-product-media]"));
    if (!thumbs.length || !mediaItems.length) return;

    const activate = (targetId) => {
      thumbs.forEach((thumb) => {
        thumb.classList.toggle("is-active", thumb.getAttribute("data-media-target") === targetId);
      });
      mediaItems.forEach((item) => {
        item.classList.toggle("is-active", item.id === targetId);
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => activate(thumb.getAttribute("data-media-target")));
    });
  });

  document.querySelectorAll("[data-product-qty]").forEach((root) => {
    const input = root.querySelector(".to-product-main__qty-input");
    const minus = root.querySelector("[data-qty-minus]");
    const plus = root.querySelector("[data-qty-plus]");
    if (!input) return;

    const clamp = () => {
      const current = Number.parseInt(input.value || "1", 10);
      input.value = Number.isFinite(current) && current > 0 ? String(current) : "1";
    };

    minus?.addEventListener("click", () => {
      clamp();
      input.value = String(Math.max(1, Number.parseInt(input.value, 10) - 1));
    });

    plus?.addEventListener("click", () => {
      clamp();
      input.value = String(Number.parseInt(input.value, 10) + 1);
    });

    input.addEventListener("change", clamp);
    clamp();
  });

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    const variantInput = form.querySelector("[data-product-variant-input]");
    const priceNode = document.querySelector("[data-product-price]");
    const submitButton = form.querySelector(".to-product-main__submit");
    const submitLabel = form.querySelector("[data-product-submit-label]");
    const variantButtons = Array.from(document.querySelectorAll("[data-product-variant]"));
    if (!variantButtons.length || !variantInput) return;

    const activate = (button) => {
      for (const item of variantButtons) {
        const isActive = item === button;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-pressed", isActive ? "true" : "false");
      }

      const variantId = button.getAttribute("data-variant-id");
      const variantPrice = button.getAttribute("data-variant-price");
      const variantAvailable = button.getAttribute("data-variant-available") !== "false";

      if (variantId) {
        variantInput.value = variantId;
      }
      if (variantPrice && priceNode) {
        priceNode.textContent = variantPrice;
      }
      if (submitButton) {
        submitButton.disabled = !variantAvailable;
      }
      if (submitLabel) {
        submitLabel.textContent = variantAvailable ? "Add to Cart" : "Sold Out";
      }
    };

    for (const button of variantButtons) {
      button.addEventListener("click", () => activate(button));
    }
  });
});

/* THE ORDINARY CART COUNT SYNC V2 START 20260722 */
(() => {
  const version = 3;
  const prior = window.__theOrdinaryCartCountSync;
  if (prior && Number(prior.version || 0) >= version) { prior.refresh(); return; }
  const fetchImpl = window.fetch.bind(window);
  const timers = new Set();
  function render(rawCount) {
    const parsed = Number(rawCount);
    const count = Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
    document.querySelectorAll('[data-to-cart-count], .to-header__cart-count').forEach((node) => {
      node.textContent = String(count);
      node.setAttribute('data-cart-count', String(count));
    });
    document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach((link) => link.setAttribute('aria-label', 'Cart (' + count + ')'));
    return count;
  }
  async function refresh() {
    try {
      const response = await fetchImpl('/cart.js?to_cart_count=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const cart = await response.json();
      render(cart.item_count);
      return cart;
    } catch (_) { return null; }
  }
  function schedule() {
    timers.forEach((timer) => window.clearTimeout(timer));
    timers.clear();
    [0, 80, 220, 500, 900, 1500, 2500, 4000, 6500, 10000].forEach((delay) => {
      const timer = window.setTimeout(() => { timers.delete(timer); refresh(); }, delay);
      timers.add(timer);
    });
  }
  window.fetch = async function (...fetchArguments) {
    const response = await fetchImpl(...fetchArguments);
    try {
      const request = fetchArguments[0];
      const url = typeof request === 'string' ? request : (request && request.url) || '';
      if (/\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/i.test(url)) {
        response.clone().json().then((cart) => {
          if (Number.isFinite(Number(cart && cart.item_count))) render(cart.item_count);
        }).catch(() => {});
        schedule();
      }
    } catch (_) { schedule(); }
    return response;
  };
  document.addEventListener('cart:update', (event) => {
    const resourceCount = event?.detail?.resource?.item_count;
    const updateCount = event?.detail?.data?.itemCount;
    if (Number.isFinite(Number(resourceCount))) render(resourceCount);
    else if (Number.isFinite(Number(updateCount))) render(updateCount);
    schedule();
  });
  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form) return;
    const action = String(form.getAttribute('action') || '');
    if (/\/cart\/add/i.test(action) || form.matches('[data-product-form]') || form.closest('product-form-component')) schedule();
  }, true);
  document.addEventListener('click', (event) => {
    const control = event.target?.closest?.('button, input[type="submit"], [role="button"]');
    if (!control) return;
    const label = [control.getAttribute('aria-label'), control.getAttribute('name'), control.textContent].filter(Boolean).join(' ');
    if (control.closest('product-form-component, cart-items-component, cart-drawer') || /add to cart|increase quantity|decrease quantity|remove/i.test(label)) schedule();
  }, true);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') schedule(); });
  window.__theOrdinaryCartCountSync = { version, render, refresh, schedule };
  schedule();
})();
/* THE ORDINARY CART COUNT SYNC V2 END 20260722 */
